import {
  collection,
  doc,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

export class ReservationsController {
  static getAll = ({ type, resolve, reject }) => {
    let errorMessage =
      "Unable to get all the reservations details.\nPlease contact administrator for assistance.";
    getDocs(collection(db, type))
      .then((data) => {
        console.debug(data);
        resolve(data);
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static get = ({ reservationSettingsId, type, resolve, reject }) => {
    let errorMessage =
      "Unable to get all the reservations details.\nPlease contact administrator for assistance.";
    const q = query(
      collection(db, type),
      where("reservationSettingsId", "==", reservationSettingsId)
    );
    getDocs(q)
      .then((data) => {
        console.debug(data);
        resolve(data);
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static add = ({ type, parameters, resolve, reject }) => {
    let errorMessage =
      "Unable to create new reservations details.\nPlease contact administrator for assistance.";
    addDoc(collection(db, type), parameters)
      .then(() => {
        resolve("New reservations details added to firebase successfully.");
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static update = ({ type, parameters, resolve, reject }) => {
    let errorMessage =
      "Unable to update the selected reservations details.\nPlease contact administrator for assistance.";
    updateDoc(doc(db, type, parameters.id), parameters)
      .then(() => {
        resolve("reservations details updated to firebase successfully.");
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static deleteAll = ({ type, idList, resolve, reject }) => {
    let errorMessage =
      "Unable to delete all the reservations details.\nPlease contact administrator for assistance.";
    const deletePromises = idList.map((id) => {
      return deleteDoc(doc(db, type, id)).catch((error) => {
        console.debug(error.message);
        throw error;
      });
    });
    Promise.all(deletePromises)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static errorHandling = ({ errorMessage, error }) => {
    switch (error.code) {
      case "permission-denied":
        errorMessage = "You are not authorised for this action.";
        break;
      default:
        break;
    }
    console.debug(error.message);
    return errorMessage;
  };
}
